module.exports = __webpack_public_path__ + "img/icn_scarpa_edit_3.60100995.png";